import Vue from 'vue'
import Router from 'vue-router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Home from './views/Home.vue'
import Kilometros from './views/Kilometros.vue'
import Sitios from './views/Sitios.vue'
import Telemetrias from './views/Telemetrias.vue'
import Disponibilidad from './views/Disponibilidad.vue'
import HistorialEntradas from './views/HistorialEntradas.vue'
import Cansancio from './views/Cansancio.vue'
import Asistencia from './views/Asistencia.vue'
import Lectoras from './views/Lectoras.vue'
import Login from './views/Login.vue'
import Fallas from './views/Fallas.vue'
import Contador from './views/Contador.vue'
import RegistrosLectoras from './views/RegistrosLectoras.vue'
import RegistrosLectorasrfid from './views/RegistrosLectorasrfid.vue'
import Operadores from './views/Operadores.vue'
import ContadorLectoras from './views/ContadorLectoras.vue'
import GruposSitios from './views/GruposSitios.vue'
import PmotorBpanico from './views/PmotorBpanico.vue'
import KilometrosOP from './views/KilometrosOP.vue'
import CansancioXRango from './views/CansancioXRango.vue'
import UnidadSinReporte from './views/UnidadSinReporte.vue'
import FallaElectricaGPS from './views/FallaElectricaGps.vue'
import ComponentLogin from './components/Login.vue'
import ReporteAsignacionesGeocercas from './views/ReporteAsignacionesGeocercas.vue'
import UnidadEnTaller from './views/UnidadEnTaller.vue'
import TicketSalidasTaller from './views/TicketSalidasTaller.vue'
import ReporteAsignacionesUsuarioSitios from './views/ReporteAsignacionesUsuarioSitios.vue'
import ReporteAsignacionesUsuarioGrupos from './views/ReporteAsignacionesUsuarioGrupos.vue'
/*import EntrevistaSocial from './components/EntrevistaInicial/EntrevistaInicialSocial.vue'
import EntrevistaEmpresa from './components/EntrevistaInicial/EntrevistaInicialEmpresa.vue'
import Proyectos from './components/Proyectos/Proyectos.vue'
import Musica from './components/Musica/FormularioMusical.vue'
import EntrevistaSocialB from './components/EntrevistaInicial/EntrevistaSocialB.vue'
import Layout from './components/Layout/Layout.vue'
import Rider from './components/Rider.vue'
import Honorarios from './components/Honorarios.vue'
import Cortejo from './components/Cortejo.vue'
import Cotizacion from './components/Cotizacion.vue'
import NuevoProyecto from './components/Proyectos/NuevoProyecto.vue'*/
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
    scrollBehavior (to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
            resolve({ x: 0, y: 0 })
            }, 0)
        })
    },
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cansancio',
      name: 'cansancio',
      component: Cansancio
    },
    {
      path: '/kilometros',
      name: 'kilometros',
      component: Kilometros,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sitios',
      name: 'sitios',
      component: Sitios
    },
    {
      path: '/telemetrias',
      name: 'telemetrias',
      component: Telemetrias
    },
    {
      path: '/disponibilidad',
      name: 'disponibilidad',
      component: Disponibilidad
    },
    {
      path: '/historicoSitios',
      name: 'historialSitios',
      component: HistorialEntradas
    },
    {
      path: '/asistencia',
      name: 'asistencia',
      component: Asistencia
    },
    {
      path: '/lectoras',
      name: 'lectoras',
      component: Lectoras
    },
    {
      path: '/',
      name: 'login',
      component: Login
    }, 
    {
      path: '/fallas',
      name: 'fallas',
      component: Fallas
    }, 
    {
      path: '/contador',
      name: 'contador',
      component: Contador
    },
    {
    path: '*', redirect: '/'  
    }, 
    {
      path: '/registrosLectoras',
      name: 'registrosLectoras',
      component: RegistrosLectoras
    },
    {
      path: '/registrosLectorasrfid',
      name: 'RegistrosLectorasrfid',
      component: RegistrosLectorasrfid
    },
    {
      path: '/operadores',
      name: 'operadores',
      component: Operadores
    },
    {
      path: '/contadorLectoras',
      name: 'contadorLectoras',
      component: ContadorLectoras
    },
    {
      path: '/gruposSitios',
      name: 'gruposSitios',
      component: GruposSitios
    },
    {
      path: '/PmotorBpanico',
      name: 'PmotorBpanico',
      component: PmotorBpanico
    },
    {
      path: '/KilometrosOP',
      name: 'KilometrosOP',
      component: KilometrosOP
    },
    {
      path: '/CansancioXRango',
      name: 'CansancioXRango',
      component: CansancioXRango
    },

    {
      path: '/UnidadSinReportar',
      name: 'UnidadSinReportar',
      component: UnidadSinReporte
    },
    {
      path: '/FallaElectricaGps',
      name: 'FallaElectricaGps',
      component: FallaElectricaGPS
    },
    {
      path: '/:user&:password',
      name: 'ComponentLogin',
      component: ComponentLogin,
      props: true,
    },{
      path: '/ReporteAsignacionesGeocercas',
      name: 'ReporteAsignacionesGeocercas',
      component: ReporteAsignacionesGeocercas,
      props: true,
    },{
      path: '/ReporteAsignacionesUsuarioSitios',
      name: 'ReporteAsignacionesUsuarioSitios',
      component: ReporteAsignacionesUsuarioSitios,
      props: true,
    },{
      path: '/ReporteAsignacionesUsuarioGrupos',
      name: 'ReporteAsignacionesUsuarioGrupos',
      component: ReporteAsignacionesUsuarioGrupos,
      props: true,
    },{
      path: '/UnidadEnTaller',
      name: 'UnidadEnTaller',
      component: UnidadEnTaller,
      props: true,
    },
    ,{
      path: '/TicketSalidasTaller',
      name: 'TicketSalidasTaller',
      component: TicketSalidasTaller,
      props: true,
    },


    
    /*{
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Rider',
      name: 'Rider',
      component: Rider
    },
	{
      path: '/Layout',
      name: 'Layout',
      component: Layout
    },
    {
      path: '/entrevistaSocial',
      name: 'EntrevistaSocial',
      component: EntrevistaSocial
    },
    {
      path: '/entrevistaEmpresa',
      name: 'EntrevistaEmpresa',
      component: EntrevistaEmpresa
    },
    {
      path: '/NuevoProyecto',
      name: 'NuevoProyecto',
      component: NuevoProyecto
    },
    {
      path: '/proyectos',
      name: 'Proyectos',
      component: Proyectos
    },
    {
      path: '/musica',
      name: 'musica',
      component: Musica
    },
    {
      path: '/boda',
      name: 'boda',
      component: EntrevistaSocialB
    },
    {
        path: '/honorarios',
        name: 'honorarios',
        component: Honorarios
    },
    {
      path: '/cortejo',
      name: 'cortejo',
      component: Cortejo
    },
    {
      path: '/Cotizacion',
      name: 'Cotizacion',
      component: Cotizacion
    },*/
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

